import { isValidMoment } from '../../../Utils/dateUtil';

const validate = (values,props) => {
    const errors = {};
    let requiredFields = [
        'hdrVendorCode',
        'hdrMainAcctNo',
        'hdrCustCompName',
      ];

    if (!values.isPdfIssue){
        if (!values.isOverrideHdrMainInvNoIfNotFound){
            requiredFields.push('hdrMainInvNo')
        }
        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'This field is required'
            }
        })

        const { projApollo,jwt } = props;
        const { validatedVendorCode, validatedAcctNo, docTemplLines, invoiceVendor, invoiceVendors} = projApollo;
        if (values['hdrVendorCode']){
            if (!invoiceVendor){
                props.selectedInvVendor(values['hdrVendorCode'],invoiceVendors);
                props.refreshAcctNos(jwt,values['hdrVendorCode']);
                props.refreshCustNames(jwt,values['hdrVendorCode']);
                props.refreshChargeDescs(jwt,values['hdrVendorCode']);
                props.refreshServiceAddress(jwt,values['hdrVendorCode']);
                props.clearAllInvoiceItems();
            }else {
                if (values['hdrVendorCode']!== invoiceVendor.code){
                    props.selectedInvVendor(values['hdrVendorCode'],invoiceVendors);
                }
            }
        }else {
            props.clearInvVendor();
            props.clearInvAcctNo();
        }

        if (values['hdrMainAcctNo']){
            if (!projApollo.invAcctNo || projApollo.invAcctNo !== values['hdrMainAcctNo']){
              props.setInvAcctNo(values['hdrMainAcctNo']);
              props.refreshCustNames(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
              props.refreshChargeDescs(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
              props.refreshServiceAddress(jwt,values['hdrVendorCode'],values['hdrMainAcctNo']);
            }
        }
        
        if (projApollo.validatedVendorNAcctNo && projApollo.validateError){
            const { field, error,value } = projApollo.validateError;
            if (values[field]!== value ) {
                props.clearValidation();
            }
        }

        if (validatedVendorCode && validatedAcctNo && values['hdrCustCompName']){
            let search = docTemplLines.find(x=>x.inv_prop_id_val===values['hdrCustCompName']);
            if (!search){
                errors['hdrCustCompName'] = 'Invalid Customer Company Name!'
            }
        }

        if (projApollo.validateError) {
            const { field, error,value } = projApollo.validateError;
            errors[field] = error;
        }
    }  
    
    if (values.hdrInvDate && !isValidMoment(values.hdrInvDate)){
        errors.hdrInvDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }
    
    if (values.hdrPayDate && !isValidMoment(values.hdrPayDate)){
        errors.hdrPayDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }
    return errors;
}

const validateAddNewItem = (values,props) => {
    const errors = {};
    const { isOverrideColPServiceAddress,projApollo }=props;
    
    let requiredFields = [
        'colLChargeDesc',
        'colMCharge'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })

    if (values.colQBillingStartDate && !isValidMoment(values.colQBillingStartDate)){
        errors.colQBillingStartDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }
    if (values.colRBillingEndDate && !isValidMoment(values.colRBillingEndDate)){
        errors.colRBillingEndDate = 'Invalid date format for this pattern MM/DD/YYYY'
    }

    if (values.colQBillingStartDate && values.colRBillingEndDate){
        if (values.colQBillingStartDate.isAfter(values.colRBillingEndDate)){
            errors['colQBillingStartDate'] = 'This date is greater than end date'
            errors['colRBillingEndDate'] = 'This date is less than start date'
        }
    }

    if (!props.isOverrideColPServiceAddress && values['colPServiceAddress']){
        const { invItemServiceAddrs } = projApollo;
        let search = invItemServiceAddrs.find(x=> x.code ===values['colPServiceAddress']);
        if (!search){
            errors['colPServiceAddress'] = 'Invalid Service Address!'
        }   
    }

    return errors;
}

exports.validate=validate
exports.validateAddNewItem=validateAddNewItem


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/others/validation.js